import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from "@/Factories/BaseApiFactory";

export class ShowTrackingLinkService {
    public static readonly $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    GetOrderTrackTraces(sapOrderNumber: string, countryCode: string) {
        return this.baseApiFactory.getData<any[]>('/api/Order/GetOrderDeliveryTrackTrace', {sapOrderNumber, countryCode});
    }
}

lazyRegister.service('ShowTrackingLinkService', ShowTrackingLinkService);